import React from 'react'
import { BlinkProvider } from './Result/BlinkProvider'
import { OpenProvider } from './Result/OpenProvider'
import { FirestoreWebProvider } from '../Firebase/FirestoreWebProvider'
import { DialogManager } from './Dialog/DialogProvider'
import { AuthProvider } from '../Firebase/AuthProvider'
import AdminCheck from '../Components/Admin/AdminCheck'
import { BlogProvider } from '../Firebase/BlogProvider'
import { ResultDataProvider } from './Result/ResultDataProvider'
import { MobileMenuProvider } from '../Components/MobileBar/MobileMenuProvider'
import { SectionProvider } from './Result/SectionProvider'
import { ResultSettingsProvider } from './Result/ResultSettingsProvider'
import { AnyProvider } from './AnyProvider'
import { AdminProvider } from '../Components/Admin/AdminContext'

export function DefaultProviders({ children }) {
    return (
        <DialogManager>
            <AuthProvider>
                <MobileMenuProvider>
                    <FirestoreWebProvider>
                        <BlogProvider>
                            <AnyProvider>
                                {children}
                            </AnyProvider>
                        </BlogProvider>
                    </FirestoreWebProvider>
                </MobileMenuProvider>
            </AuthProvider>
        </DialogManager>
    )
}

export function AdminProviders({ children }) {
    return <DefaultProviders>
        <AdminCheck>
            <AdminProvider>
                {children}
            </AdminProvider>
        </AdminCheck>
    </DefaultProviders>
}

export function ResultProviders({ children }) {
    return (
        <DefaultProviders>
            <ResultSettingsProvider>
                <ResultDataProvider>
                    <BlinkProvider>
                        <OpenProvider>
                            <SectionProvider>
                                {children}
                            </SectionProvider>
                        </OpenProvider>
                    </BlinkProvider>
                </ResultDataProvider>
            </ResultSettingsProvider>
        </DefaultProviders>
    )
}

export function PublicProviders({ children }) {
    return (
        <DefaultProviders>
            {children}
        </DefaultProviders>
    )
}
